import { defineMessages } from 'react-intl';

export const customerFilterMessages = defineMessages({
  deselectAllFilters: {
    id: 'customer_filter.deselect_all_filters',
    defaultMessage: 'Deselect all filters',
    description: 'Title of the deselect all filters button',
  },
  flowStarted: {
    id: 'customer_filter.flow_started',
    defaultMessage: 'Flow started',
    description: 'Flow started filter',
  },
  aggregationStarted: {
    id: 'customer_filter.bank_connection_started',
    defaultMessage: 'Aggregation started',
    description: 'Bank connection started filter',
  },
  inError: {
    id: 'customer_filter.in_error',
    defaultMessage: 'In error',
    description: 'In error filter',
  },
  withoutAnalysis: {
    id: 'customer_filter.without_analysis',
    defaultMessage: 'Without analysis',
    description: 'The label of customers without analysis',
  },
});
